// =============================================================================
// Some Variable testing functions to ensure data is returned correctlly
// =============================================================================


export function setCookie(name: string, value: string, days: number) {
  if (document) {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = `; expires=${date.toUTCString()}`
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`
  }
}

export function getCookie(name: string) {
  if (document) {
    const nameEQ = `${name}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0)
        return c.substring(nameEQ.length, c.length)
    }
    return null
  }
}
export function deleteCookie(name: string) {
  if (document)
    document.cookie = `${name}=; Max-Age=-99999999;`
}
export function isObject(variable: object) {
  return typeof variable === 'object' && variable !== null
}

export function keyInObject(obj: object, key: string) {
  return !!Object.prototype.hasOwnProperty.call(obj, key)
}

export function testKeyChain(obj: object, keys: Array<string>) {
  let success = true
  let testObj = {}
  let testKey = ''

  for (let i = 0; i < keys.length; i++) {
    if (i === 0) {
      testObj = obj
      testKey = keys[i]
    }
    else {
      testKey = keys[i]
      testObj = testObj[keys[i - 1]]
    }

    if (!Object.prototype.hasOwnProperty.call(testObj, testKey)) {
      success = false
      break
    }
  }
  return success
}

export function timestamp(): number {
  return Math.floor(Date.now() / 1000)
}

export function KIO(obj, key, mode = 'and') {
  // Obj => object in question
  // key => string or Array
  // mode => 'and' (default) || 'chain'
  // -> If mode is set to 'and' it implies that an array has been passed, it will check if the object contains all the keys present in the array
  // -> If mode is set to 'chain' it implies that an array has been passed, it will check if the object contains, the first key, then the second, then the third as children in a chained sequence.
  //    Example: ['auth', 'data', 'id'] -> KIO($user, 'auth') && KIO($user.auth, 'data') && KIO($user.auth, 'id')

  if (!isObject(obj))
    return false

  if (Array.isArray(key) && key.length > 0) {
    const keys = key
    if (mode === 'and') {
      return keys.every((key) => {
        return Object.prototype.hasOwnProperty.call(obj, key)
      })
    }
    else if (mode === 'chain') {
      return testKeyChain(obj, keys)
    }
    else {
      throw new Error('bad "Mode" set for "KIO"')
    }
  }
  else if (typeof key === 'string') {
    try {
      if (Object.prototype.hasOwnProperty.call(obj, key))
        return true

      else
        return false
    }
    catch (e) {
      throw new Error('Problem with data within "keyInObject" utility function')
    }
  }
  else {
    return false
  }
}

export function KIOL(obj, key, mode = 'and') {
  // Obj => object in question
  // key => string or Array
  // mode => 'and' (default) || 'chain'
  // -> If mode is set to 'and' it implies that an array has been passed, it will check if the object contains all the keys present in the array
  // -> If mode is set to 'chain' it implies that an array has been passed, it will check if the object contains, the first key, then the second, then the third as children in a chained sequence.
  //    Example: ['auth', 'data', 'id'] -> KIO($user, 'auth') && KIO($user.auth, 'data') && KIO($user.auth, 'id')
  if (!isObject(obj))
    return false

  if (Array.isArray(key) && key.length > 0) {
    const keys = key
    if (mode === 'and') {
      return keys.every((key) => {
        return (
          Object.prototype.hasOwnProperty.call(obj, key) && obj[key].length > 0
        )
      })
    }
    else if (mode === 'chain') {
      return testKeyChain(obj, keys, 'KIOL')
    }
    else {
      throw new Error('bad "Mode" set for "KIOL"')
    }
  }
  else if (typeof key === 'string') {
    try {
      if (
        obj
        && isObject(obj)
        && Object.prototype.hasOwnProperty.call(obj, key)
        && obj[key].length > 0
      )
        return true

      else
        return false
    }
    catch (e) {
      throw new Error('Problem with data within "keyInObject" utility function')
    }
  }
  else {
    return false
  }
}

export function KIOE(obj, key, mode = 'and') {
  // Obj => object in question
  // key => string or Array
  // mode => 'and' (default) || 'chain'
  // -> If mode is set to 'and' it implies that an array has been passed, it will check if the object contains all the keys present in the array
  // -> If mode is set to 'chain' it implies that an array has been passed, it will check if the object contains, the first key, then the second, then the third as children in a chained sequence.
  //    Example: ['auth', 'data', 'id'] -> KIO($user, 'auth') && KIO($user.auth, 'data') && KIO($user.auth, 'id')

  if (!isObject(obj))
    return false

  if (Array.isArray(key) && key.length > 0) {
    const keys = key
    if (mode === 'and') {
      return keys.every((key) => {
        return Object.prototype.hasOwnProperty.call(obj, key) && obj[key]
      })
    }
    else if (mode === 'chain') {
      return testKeyChain(obj, keys, 'KIOE')
    }
    else {
      throw new Error('bad "Mode" set for "KIOE"')
    }
  }
  else if (typeof key === 'string') {
    try {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key])
        return true

      else
        return false
    }
    catch (e) {
      throw new Error('Problem with data within "keyInObject" utility function')
    }
  }
  else {
    return false
  }
}

export function falseWithZero(value) {
  return value || value === 0
}

// =============================================================================
// STRINGS
// =============================================================================
export function wrapHashtags(str) {
  const regex = /#[A-Za-z0-9_-]*/g
  if (str && str.length > 0)
    return str.replace(regex, '<span class="hashtag">$&</span>')

  else
    return str
}
export function wrapMentions(str) {
  const regex = /@[A-Za-z0-9_-]*/g
  if (str && str.length > 0)
    return str.replace(regex, '<span class="hashtag">$&</span>')

  else
    return str
}

export function firstToUpper(str) {
  if (str && str.length > 0)
    return str.charAt(0).toUpperCase() + str.slice(1)

  else
    return str
}

export function capFirst(str) {
  if (str && str.length > 0)
    return str.charAt(0).toUpperCase() + str.slice(1)

  else
    return str
}
export function toUpper(str) {
  if (str && str.length > 0)
    return str.toUpperCase()

  else
    return str
}

export function truncate(str, n, useWordBoundary = true) {
  if (!str || str.length <= n)
    return str

  const subString = str.substr(0, n - 1) // the original check
  return (
    `${useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(' '))
      : subString}&hellip;`
  )
}

// =============================================================================
// Window Height and Widths
// =============================================================================

export function vh(v) {
  const h = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0,
  )
  return (v * h) / 100
}

export function vw(v:number) {
  const w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0,
  )
  return (v * w) / 100
}
export function vwWithMax(v:number, max:number) {
  const w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0,
  )
  return Math.min((v * w) / 100, max)
}

export function vmin(v:number) {
  return Math.min(vh(v), vw(v))
}

export function vmax(v:number) {
  return Math.max(vh(v), vw(v))
}

export function ceilNearest(value:number, ceil:number) {
  if (value > 0 && ceil > 0)
    return Math.ceil(value / ceil) * ceil

  else
    return value
}

// =============================================================================
// STATS
// =============================================================================
export function nFormatter(num, digits) {
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let i
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value)
      break
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
}

// Find or false
export function fof(value) {
  if (value === 0)
    return 0

  else
    return value || false
}

// Get the destination index for panel pagination
export function getPaginateIndex(collection, activeIndex, intent) {
  // Base obj to reference
  // Active index
  // Intent value
  let count = 0

  let min = 0

  let max = 0

  if (typeof collection === 'object' && collection !== null) {
    count = Object.keys(collection).length
    min = 0
    max = count - 1
  }
  else if (Array.isArray(collection)) {
    count = collection.length
  }
  else {
    return false
  }

  min = 0
  max = count ? count - 1 : 0

  // if (!(activeIndex || activeIndex === 0) || !intent) {
  //   return false
  // }

  if (typeof intent === 'number') {
    if (intent >= min && intent <= max) {
      // commit('SET_ACTIVE_NODE', intent)
      return intent
    }
  }
  if (typeof intent === 'string') {
    let toNode
    switch (intent) {
      case 'prev':
        toNode = activeIndex - 1
        if (toNode >= min) {
          // commit('SET_ACTIVE_NODE', toNode)
          return toNode
        }
        break
      case 'next':
        toNode = activeIndex + 1
        if (toNode <= max) {
          // commit('SET_ACTIVE_NODE', toNode)
          return toNode
        }
        break
    }
  }
}

// NUXT SPECIFIC


export const scrollToTopOnLoad = {
  mounted() {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0)
    }
  },
}

export function shuffle<T>(a: Array<T>) {
  let j, x, i
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1))
    x = a[i]
    a[i] = a[j]
    a[j] = x
  }
  return a
}

export function AE(arr: Array<unknown>) {
  return Array.isArray(arr)
}
export function AEL(arr: Array<unknown>) {
  return Array.isArray(arr) && arr.length > 0
}

export function rand(min: number, max: number) {
  if (!Number.isNaN(min) && !Number.isNaN(min))
    return Math.floor(Math.random() * (max - min + 1) + min)

  else
    return false
}

// SURREAL HELPER FUNCTIONS




export function formatPrice(amount: number, currencyCode: string, quantity: number = 1) {
  return `${(amount / 100 * quantity).toFixed(2)
    } ${
    currencyCode.toUpperCase()}`
}

// return the last result of the query


export function hexToRgb(hex: string) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i

  hex = hex.replace(shorthandRegex, (m: string, r: string, g: string, b: string) => {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return result ? `${Number.parseInt(result[1], 16)},${Number.parseInt(result[2], 16)},${Number.parseInt(result[3], 16)}` : null
}


export function createPermalinkSlug(str: string) {
  // Convert the label to lowercase
    let slug = str.toLowerCase()
  
    // Replace spaces with hyphens
    slug = slug.replace(/\s+/g, '-')
  
    // Remove non-alphanumeric characters (except hyphens)
    slug = slug.replace(/[^a-z0-9-]/g, '')
  
    // Remove consecutive hyphens (if any)
    slug = slug.replace(/-+/g, '-')
  
    // Remove leading and trailing hyphens (if any)
    slug = slug.replace(/^-|-$/g, '')
  
    return slug
  }



  /**
 * Checks if a provided Vue ref contains a specified function and, if it does, calls that function with the provided event.
 *
 * This utility function is useful in scenarios where you need to ensure that a reference is correctly calculated and that a 
 * specific method exists on the referenced component or element. If the method exists, it will be called with the given event.
 * If the method does not exist, a warning will be logged to the console.
 *
 * @param {Ref<any>} refEl - The Vue ref to be checked. It can contain any type of value.
 * @param {string} functionName - The name of the function to check for on the ref's value.
 * @param {Event} event - The event to pass to the function when it is called.
 *
 * @example
 * const menuref = ref<any>();
 * 
 * function toggle(event: Event) {
 *   console.log("menuref", menuref.value);
 *   isRefElAndFunctionExists(menuref, 'toggle', event);
 * }
 */
  export function isRefAndFnExists(
    refEl: Ref<any>, 
    functionName: string, 
    event: Event
  ): void {
    if (isRef(refEl) && refEl.value && typeof refEl.value[functionName] === 'function') {
      // Run the function
      (refEl.value[functionName] as Function)(event);
    } else {
      console.warn(`The provided reference does not contain a function named ${functionName}.`);
    }
  }
  